import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { signOut } from '../auth-compat';
import { collection, query, where, getDocs } from '../firestore-compat';
import { useNavigate, useLocation } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import '../App.css';
import { SeletorVisual, carregarVisualDoCadastro } from './Vidro';
import { ehTelaDePainel } from '../hooks/useLogoutPorInatividade';

const SUPER_ADMIN = 'alexandrebareaoliveira@gmail.com';

// Barra do topo (como no INEP): nome, perfil, foto/iniciais e Sair
const TopBar = ({ toggleSidebar }) => {
    const user = auth.currentUser;
    const navigate = useNavigate();
    const location = useLocation();
    const [perfil, setPerfil] = useState({ nome: '', rotulo: '', foto: '' });
    const [docId, setDocId] = useState(null);

    useEffect(() => {
        if (!user?.email) return;
        let ativo = true;
        getDocs(query(collection(db, 'users'), where('email', '==', user.email.toLowerCase())))
            .then(snap => {
                if (!ativo || snap.empty) return;
                const d = snap.docs[0].data();
                const roles = Array.isArray(d.roles) ? d.roles : (d.role ? [d.role] : []);
                const rotulo = user.email === SUPER_ADMIN ? 'Admin master'
                    : (roles.includes('admin') || roles.includes('administrador')) ? 'Administrador'
                    : (d.perfilName || (roles[0] ? roles[0].charAt(0).toUpperCase() + roles[0].slice(1) : 'Colaborador'));
                setPerfil({ nome: d.agendaName || d.name || user.email, rotulo, foto: d.photoURL || '' });
                setDocId(snap.docs[0].id);
                carregarVisualDoCadastro(d.preferencias?.visual);
            })
            .catch(() => {});
        return () => { ativo = false; };
    }, [user?.email]);

    const handleLogout = async () => {
        await signOut(auth);
        navigate('/login');
    };

    const nome = perfil.nome || user?.email || '';
    const iniciais = nome.split(/[\s@.]+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('');

    return (
        <header className="top-bar">
            <div className="top-bar-left">
                <button className="btn-toggle-sidebar" onClick={toggleSidebar}>
                    ☰
                </button>
            </div>
            <div className="top-bar-right">
                {/* nas telas de painel (TVs) o vidro fica sempre desligado — o botão só confundiria */}
                {!ehTelaDePainel(location) && <SeletorVisual docId={docId} />}
                <div className="tb-usuario" title={user?.email}>
                    <strong>{nome}</strong>
                    {perfil.rotulo && <span>{perfil.rotulo}</span>}
                </div>
                <button className="tb-sair" onClick={handleLogout}><LogOut size={14} /> Sair</button>
                {perfil.foto
                    ? <img className="tb-avatar" src={perfil.foto} alt="" />
                    : <span className="tb-avatar">{iniciais}</span>}
            </div>
        </header>
    );
};

export default TopBar;
